import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from "../BrandLogo";
import { Mail, MessageCircle, Phone } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BUSINESS_ADDRESS_LINES, BUSINESS_IDENTITY } from '@/config/businessIdentity';
export const FooterCompanyInfo = () => {
  const [whatsAppOpen, setWhatsAppOpen] = React.useState(false);
  const openWhatsApp = () => {
    const text = "Hi Dialgia team, I’d like to connect via WhatsApp.";
    const url = `${BUSINESS_IDENTITY.whatsapp.href}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return <div className="lg:col-span-1">
      {/* Wrap logo in a div with a ref for measurement - progressive responsive sizing */}
      <div className="flex justify-start">
        <BrandLogo variant="horizontal" size={65} className="h-[60px] md:h-[65px] lg:h-[70px] w-auto" />
      </div>
      {/* Badge: left-aligned without border */}
      <div className="flex items-start justify-start mt-2">
        <div className="text-gray-300 text-xs px-0 py-0.5">AI + Human Powered Business Solutions</div>
      </div>
      
      {/* Grouped Company Information */}
      <div className="mt-4 space-y-2 text-sm">
        <div className="text-gray-300 font-medium text-white">{BUSINESS_IDENTITY.brandName}</div>
        <div className="text-gray-300 leading-relaxed">
          {BUSINESS_ADDRESS_LINES.map((line, index) => (
            <span key={line}>{index > 0 && <br />}{line}</span>
          ))}
        </div>
        <div className="text-xs text-gray-400">click to call</div>
      </div>
      
      <div className="mt-4 space-y-2">
        <div className="flex items-center text-sm text-gray-300">
          <Mail className="h-4 w-4 mr-3 text-blue-400" />
           <a href={`mailto:${BUSINESS_IDENTITY.email}`} className="inline-flex min-h-0 items-center py-0.5 leading-5 transition-colors hover:text-blue-400">
            {BUSINESS_IDENTITY.email}
          </a>
        </div>
        
        <div className="flex items-center text-sm text-gray-300">
          <MessageCircle className="h-4 w-4 mr-3 text-green-400" />
          <a href="/contact?whatsapp=1" onClick={e => {
          e.preventDefault();
          setWhatsAppOpen(true);
         }} className="inline-flex min-h-0 items-center py-0.5 leading-5 transition-colors hover:text-green-400">
            WhatsApp: {BUSINESS_IDENTITY.whatsapp.display}
          </a>
        </div>
        
        <div className="flex items-center text-sm text-gray-300">
          <Phone className="h-4 w-4 mr-3 text-blue-400" />
           <a href={BUSINESS_IDENTITY.officePhone.href} className="inline-flex min-h-0 items-center py-0.5 leading-5 transition-colors hover:text-blue-400">
            UK Office: {BUSINESS_IDENTITY.officePhone.display}
          </a>
        </div>
      </div>
      <Dialog open={whatsAppOpen} onOpenChange={setWhatsAppOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>WhatsApp Chat</DialogTitle>
            <DialogDescription>
              We’ll open WhatsApp in a new tab. Send us your message and our team will reply as soon as possible.
            </DialogDescription>
          </DialogHeader>
          <div className="flex items-center justify-between gap-3">
            <Button onClick={openWhatsApp} className="flex-1">Open WhatsApp</Button>
            <Button variant="outline" className="flex-1" asChild>
              <Link to="/contact?whatsapp=1">Use site chat</Link>
            </Button>
          </div>
          <DialogFooter className="text-xs text-gray-400">
            By continuing you agree to contact us via WhatsApp.
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>;
};
